/**
 * These are the utm params which when present in an ADP URL will trigger the quick view.
 * In addition to these, "?quick=view" will also trigger the quick view.
 * Use "?view=adp" to force the normal ADP view. Presence of any other quick view triggering query params will be ignored and the normal ADP view will be shown.
 */
const UTM_PARAMS_TRIGGERING_QUICK_VIEW_LIST = [
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_campaign',
  'utm_content',
  'utm_id',
  'gclid',
] as const;

const UTM_PARAMS_LIST = [
  ...UTM_PARAMS_TRIGGERING_QUICK_VIEW_LIST,
  'gc',
  'emst',
  'ef_id',
  'cpc',
  'organic',
  'pla',
  'display',
  'social',
  'retargeting',
  'psm',
  'affiliate',
  'email',
  'reload',
  'product_ID',
  'variant_ID',
  'C_ID',
  'srsltid',
  'gclsrc',
  'dclid',
  'gbraid',
  'wbraid',
  'pb', // payback and tradedoubler param
] as const;

export const UTM_PARAMS = new Set(UTM_PARAMS_LIST);
const UTM_PARAMS_TRIGGERING_QUICK_VIEW = new Set(
  UTM_PARAMS_TRIGGERING_QUICK_VIEW_LIST,
);

export const hasMarketingDirectEntryQueryParams = (
  params: URLSearchParamsWithUtm,
) => {
  if (params.size === 0) {
    return false;
  }
  for (const [key] of params) {
    const hasParam = (
      UTM_PARAMS_TRIGGERING_QUICK_VIEW as unknown as Set<string>
    ).has(key);
    if (hasParam) return true;
  }
  return false;
};

type UtmParamKey = (typeof UTM_PARAMS_LIST)[number];

type AllowedUtmParams = {
  [K in UtmParamKey]?: string;
};

type DisallowedUtmParams = {
  [K in UtmParamKey]: never;
};

export interface URLSearchParamsWithUtm
  extends URLSearchParams,
    AllowedUtmParams {
  get(key: UtmParamKey): string | null;
  get(key: string): string | null;
  keys(): URLSearchParamsIterator<UtmParamKey>;
  readonly size: number;
}

export interface URLSearchParamsWithoutUtm
  extends URLSearchParams,
    DisallowedUtmParams {
  get(key: UtmParamKey): never;
  get(key: string): string | null;
  readonly size: number;
}
